import {BaseAuthenticationMethod} from './base-authentication-method';

export class Csc extends BaseAuthenticationMethod {
    type = 'csc';
    automaticValidation?: boolean;
    surName?: string;
    givenName?: string;
    birthDate?: Date;
    allowedCSCProviders?: string[];
    visualSignatureRequired?: boolean;
}
